/**
 * [退款列表]
 * @author: Fu Xiaochun
 * @date: 2021-09-27 
 */

import http from '@/assets/api/http';

// 退款列表
export async function getRefundList(params){
    return http('/?cmd=com.xqxc.api.pig.mis.pay.RefundMisService.getRefundInfo', params, 'POST');
}

// 退款汇总统计
export async function getRefundSummary(params){
    return http('/?cmd=com.xqxc.api.pig.mis.pay.RefundMisService.getRefundSummary', params, 'POST');
}

// 手动退款
export async function toReFund(params){
    return http('/?cmd=com.xqxc.api.pig.mis.pay.RefundMisService.manualRefund', params, 'POST');
}